export const FUND_REPRESENTATIVE_SCHEMA_ID = 'fund-representative';

export type AppRole = 'representative' | 'admin';

export function schemaIdToRole(schemaId?: string): AppRole {
  if (schemaId === FUND_REPRESENTATIVE_SCHEMA_ID) {
    return 'representative';
  }
  return 'admin';
}

export function roleHomePath(role: AppRole): string {
  if (role === 'representative') {
    return '/applications';
  }
  return '/accounts/admins';
}
